<template>
  <div style="margin-top: -10px;">
      <div class="row">
          <div class="col-8">
              <div class="text-left section-title" style="padding: 5px;">
                  <span class="row-table-font-margins" style="font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center"> {{ buildingName }} / Expenses By Month</span>
              </div>
          </div>
          <div class="col-4 add-button-section">
              <div class="text-right" style="padding: 5px;">
                  <!--<span style="margin-right:5px">Add New Unit</span>
            <router-link class="btn btn-table" :to="{
      name: 'property',
      params: { buildingId: buildingId, buildingName: buildingName },
    }"><i class="fas fa-plus"></i></router-link>-->
                  <span style="width: 30px;
height: 30px;
border-radius: 5px;
            background-color: #007DFC;
            color: white;
            display: inline-block;
            padding-left: 5px;
            padding-right: 5px;
            text-align: center;
            margin-right:8px;
          ">
                      <i class="fa fa-sliders-h" style="margin-top:7px;transform: rotate(-90deg);" aria-hidden="true"></i>
                  </span>

                  <span @click="showSearch()"
                        style="
                          width: 30px;
                          height: 30px;
                          border-radius: 5px;
                          background-color: #007DFC;
                          color: white;
                          display: inline-block;
                          padding-left: 5px;
                          padding-right: 5px;
                          text-align: center;
                          cursor:pointer;

                          ">
                      <i class="fa fa-search" style="margin-top:7px;" aria-hidden="true"></i>
                  </span>

                  <input type="text" v-if="visibleSearch" class="form-control" name="searchText" id="searchText" style=" display: inline-block; width: 250px; height: 30px;" v-model="filter">
                  <span @click="exportToPDF()"
                        style="
width: 30px;
height: 30px;
border-radius: 5px;
background-color: #007DFC;
color: white;
display: inline-block;
padding-left: 5px;
padding-right: 5px;
text-align: center;
cursor:pointer;
margin-left:5px;
">
                      <i class="fa fa-file-export" style="margin-top:7px;" aria-hidden="true"></i>
                  </span>
                  <userMenu />
              </div>
          </div>
      </div>
    <div class="row">
      <div class="col-12 pull-center">
        <div class="form-group">
          <span
          style="
width: 30px;
height: 30px;
border-radius: 5px;
            background-color: #4586c6;
            color: white;
            display: inline-block;
            padding-left: 5px;
            padding-right: 5px;
          "
        >
          <i class="fa fa-sliders-h" style="margin-top:7px" aria-hidden="true"></i></span
        >
          <select
            class="select"
            id="month_value"
            name="month_value"
            v-model="month"
            v-on:change="onChange"
          >
            <option value="1">January</option>
            <option value="2">February</option>
            <option value="3">March</option>
            <option value="4">April</option>
            <option value="5">May</option>
            <option value="6">June</option>
            <option value="7">July</option>
            <option value="8">August</option>
            <option value="9">September</option>
            <option value="10">October</option>
            <option value="11">November</option>
            <option value="12">December</option>
          </select>
        </div>
      </div>
    </div>
    <div class="table-responsive" id="additional-report">
      <table class="table table-condensed">
        <thead >
          <tr>
            <th scope="col"></th>
            <th
              scope="col"
              v-for="expenseType in expenseTypes"
              :key="expenseType.id"
            >
              {{ expenseType.name }}
            </th>
            <th scope="col">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(propertyFee, key, index) in propertyFees" :key="index">
            <td scope="row">
              <strong> {{ propertyFee.propertyName }}</strong>
            </td>
            <td v-for="(fee, key2) in propertyFee.fees" :key="key2">
              <div v-if="key2 < 12">
                <div v-if="fee == 0">
                  
                </div>
                <div v-else>
                  {{ $filters.toCurrency(fee) }}
                </div>
              </div>
              <div v-else>
                <strong>
                  <div v-if="fee == 0">
                    
                  </div>
                  <div v-else>
                    {{ $filters.toCurrency(fee) }}
                  </div>
                </strong>
              </div>
            </td>
          </tr>
          <tr>
            <td scope="row">
              <strong>Total</strong>
            </td>
            <td v-for="(total, index) in totalFees" :key="index">
              <strong>
                <div v-if="total == 0">
                  
                </div>
                <div v-else>
                  {{ $filters.toCurrency(total) }}
                </div>
              </strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { format } from "date-fns";
import { mapState } from "vuex";
import html2pdf from "html2pdf.js"
export default {
  data: function () {
    return {
      propertyFees: [],
      totalFees: [],
      expenseTypes: [],
      buildingId: 0,
    //  buildingName: "",
      month: 1,
      visibleSearch: false,
      filter: "",
    };
  },
  mounted() {
    this.buildingId = this.$route.params.buildingId;
    //this.buildingName = this.$route.params.buildingName;
    //this.buildingName = this.$route.params.buildingName;
    this.fetchStatement();
  },
  computed:{
    ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
  },
  methods: {
    showSearch() {
      this.visibleSearch = !this.visibleSearch;
    },
    onChange: function () {
      this.fetchStatement();
    },
            exportToPDF() {
    html2pdf(document.getElementById("additional-report"), {
        margin: 1,
        filename: "additional-report.pdf",
        html2canvas: { scale: 2 },
        enableLinks: false,
        jsPDF: { orientation: 'landscape' }
    });
},
    fetchStatement: function () {
      this.mute = true;
      //this.buildingId = 3;
      var request =
        "/expenses/bymonth?id=" + this.buildingId + "&month=" + this.month;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.propertyFees = data.propertyFees;
          this.totalFees = data.totalFees;
          this.expenseTypes = data.expenseTypes;
        });
    },
    customFormatter(date) {
      return format(date, "dd/MM/yyyy");
    },
  },
};
</script>
